import request from '@/utils/request'
const apiPrefix = '/prod-api'

// 查询字典
export function getAllDictReg(params = {}) {
  return request.get(`${apiPrefix}/base/lookupItem/findAllLookupItem`, { params })
}

/**
 * @description 根据语言获取国际化配置
 * @returns
 */
export function getI18nMapReg(params = {}) {
  return request.get(`${apiPrefix}/base/i18n/findI18nMap`, { params })
}

// 获取用户详细信息
export function getUserInfoReq() {
  return request.get(`${apiPrefix}/getInfo`, {})
}

// 切换组织
export function switchGroupReq(groupId: number) {
  return request.get(`${apiPrefix}/switch-org/${groupId}`)
}

// 获取app二维码下载地址
export function getAPPUrl() {
  return (request as any).get(`${apiPrefix}/system/config/configKey/sys.app.url`, {
    isNotMessage: true
  })
}

// 获取pda二维码下载地址
export function getPDAUrl() {
  return (request as any).get(`${apiPrefix}/system/config/configKey/sys.pda.url`, {
    isNotMessage: true
  })
}

// 获取注册二维码下载地址
export function getGenerateQrCode() {
  return (request as any).get(`${apiPrefix}/base/user-info/generateQrCode`, { isNotMessage: true })
}
